import React, { ComponentType } from "react";
import { react2Angular } from "~/Core/React2Angular";
import { TS } from "~/Services/TS";
import { useOptionsContext } from "~/Contexts/OptionsContext";
import Cookies from "js-cookie";
import { useSingleSpaParcel } from "~/Hooks/SingleSpaParcel";

export const SearchService = () => {
    let options = useOptionsContext();

    let accessToken = Cookies.get("opti_id_token");
    if (!accessToken && !window.location.href.includes("localhost")) {
        return (
            <div className="grid-block vertical">
                <div className="title-bar">
                    <div>{TS("Access Denied. Please log in using Optimizely ID SSO to view this page.")}</div>
                </div>
            </div>
        );
    }

    let importName = "@optimizely/commerce-search-service";
    let parcel = useSingleSpaParcel(importName, {
        optiProjectId: options.environment.projectIdentifier,
        accessToken: accessToken,
    });

    if (parcel === null) {
        console.warn("no parcel found!! for " + importName);
        return null;
    }

    return (
        <div className="grid-block vertical">
            <div className="title-bar">
                <h1 className="title left">{TS("Commerce Search v3")}</h1>
            </div>

            <div className="grid-block">
                <div className="parcel-container">{parcel}</div>
            </div>
        </div>
    );
};

angular.module("insite-admin").component("searchService", react2Angular(SearchService));
